import axios from "axios";

export const state = {
    savings: [],
};

export const getters = {
    savings: state => state.savings,
};

export const mutations = {
    setSaving(state, newValue) {
        state.savings = newValue
    },
};

export const actions = {
    fetchSavings({ commit }) {
        axios.get('/patientsavings').then(res => {
            commit('setSaving', res.data.savings);
        })
    },
};
